import { DateTime } from 'luxon'
import { defineStore } from 'pinia'

export const usePhoneStore = defineStore({
  // unique id of the store across your application
  id: 'phone',
  state: () => ({
    status: 'NOT_CONNECTED',
    statusChangedAt: DateTime.now(),
  }),
  getters: {},
  actions: {
    setStatus(status: string) {
      this.status = status
      this.statusChangedAt = DateTime.now()
    },
  },
})
